import { urls } from './urls';

export const flagValueToPathMap = {
  home: urls.home,
  payments: urls.payments,
  direct_finance: urls.directFinance,
  early_payment: urls.earlyPayment,
};
